export const EMAIL_REGEX = /^[\w-\.+_-]+@([\w-]+\.)+[\w-]{2,4}$/;
export const PASSWORD_REGEX = /^^(?=.*[A-Za-z0-9])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,20}$/;
export const MOBILE_REGEX = /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/;
export const NAME_REGEX = /^[A-Za-z][A-Za-z0-9-_ ]{2,30}$/;